import React, { useState, useEffect } from "react";
import { postApiWithAuth } from "../../../services/api/api";
import Slider from "react-slick";

const ProfileTab = ({ initialProfileData, fallbackPhoto, navigate }) => {
    const [userProfileData, setUserProfileData] = useState(initialProfileData);
const [selectedProfileIndex, setSelectedProfileIndex] = useState(null);

const profilePhotos = (userProfileData?.profile_photos || [])
    .map((p) => p?.photo)
    .filter((url) => url && url !== "null");

const profileMedia = [
    ...profilePhotos.map((url) => ({
        url,
        type: "image",
    })),

    ...(userProfileData?.main_video
        ? [{ url: userProfileData.main_video, type: "video" }]
        : []),
];
const nextProfilePhoto = (e) => {
    e.stopPropagation();

    setSelectedProfileIndex((prev) =>
        prev === profileMedia.length - 1 ? 0 : prev + 1
    );
};

const prevProfilePhoto = (e) => {
    e.stopPropagation();

    setSelectedProfileIndex((prev) =>
        prev === 0 ? profileMedia.length - 1 : prev - 1
    );
};
const photoGallery_slider = {
    dots: false,
    infinite: false,
    speed: 500,
    slidesToShow: 5,
    slidesToScroll: 1,
    arrows: false,
    swipe: false,
    draggable: false,
    touchMove: false,
    centerMode: false,   // ensure center mode is disabled
    variableWidth: false,

    responsive: [
        { breakpoint: 1024, settings: { slidesToShow: 3 } },
        { breakpoint: 768, settings: { slidesToShow: 3 } },
        { breakpoint: 480, settings: { slidesToShow: 3 } },
    ],
};

    useEffect(() => {
        const syncServerProfileData = async () => {
            try {
                const storedProfileStr = localStorage.getItem("profile_data");
                let targetProfileId = initialProfileData?.id || null;

                if (storedProfileStr) {
                    const parsed = JSON.parse(storedProfileStr);
                    const profile = Array.isArray(parsed) ? parsed[0] : parsed;
                    targetProfileId = profile?.id || targetProfileId;
                }

                if (!targetProfileId) {
                    console.log("No profile record reference located. Redirecting to initialization wizard...");
                    navigate("/CreateProfile");
                    return;
                }

                const response = await postApiWithAuth("/get-profile", { profile_id: targetProfileId });
                console.log('response',response);
                if (response?.data && Object.keys(response.data).length > 0) {
                    setUserProfileData(response.data);
                } else {
                    console.log("Profile reference missing from database. Routing to initialization wizard...");
                    navigate("/CreateProfile");
                }
            } catch (error) {
                console.error("Failed to rehydrate ProfileTab context from backend api:", error);
                navigate("/CreateProfile");
            }
        };
        syncServerProfileData();
    }, [initialProfileData, navigate]);

    const formatDate = (dateString) => {
        if (!dateString || dateString === "NA") return "NA";

        const dateObj = new Date(dateString);
        if (isNaN(dateObj.getTime())) return dateString;

        return dateObj.toLocaleDateString("en-GB", {
            day: "numeric",
            month: "short",
            year: "numeric",
        });
    };

    const formatHeight = (heightValue) => {
        if (!heightValue || heightValue === "NA") return "NA";

        const heightStr = String(heightValue);
        const parts = heightStr.split(".");
        const feet = parts[0];
        let inches = "0";

        if (parts[1]) {
            const subSegment = parts[1].substring(0, 2);
            const parsedVal = parseInt(subSegment, 10);

            if (!isNaN(parsedVal) && parsedVal >= 0 && parsedVal <= 11) {
                inches = String(parsedVal);
            }
        }

        return `${feet}ft ${inches}in`;
    };

    const formatName = (name) => {
        if (!name || typeof name !== "string") return "NA";
        return name
            .toLowerCase()
            .split(" ")
            .filter(Boolean)
            .map((word) => word.charAt(0).toUpperCase() + word.slice(1))
            .join(" ");
    };

    const getStorageMobileNumber = () => {
        try {
            const userDetailsStr = localStorage.getItem("userDetails");
            if (userDetailsStr) {
                const details = JSON.parse(userDetailsStr);
                return details.mobile || "";
            }
        } catch (err) {
            console.error("Failed to extract session phone reference metrics from cache:", err);
        }
        return "";
    };

    const activeMobileDisplay = getStorageMobileNumber() || userProfileData?.mobile || "NA";
    const activePhoto = userProfileData?.main_photo || fallbackPhoto || `${process.env.PUBLIC_URL}/assets/imgs/default_user.jpeg`;

    return (
        <div className="tab-content-box">
            <div className="profile-wrapper">
                <div className="row">
                    <div className="col-lg-6 mb-4 d-none">
                        <div className="info-card">
                            <div className="profile-image-box">
                                <img
                                    src={activePhoto}
                                    alt="Main Profile"
                                    className="main-profile-img"
                                    onError={(e) => { e.target.src = `${process.env.PUBLIC_URL}/assets/imgs/default_user.jpeg`; }}
                                />
                                <button className="edit-profile-btn" onClick={() => navigate("/CreateProfile")}>
                                    Edit Profile
                                </button>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-12 mb-4">
                        <div className="info-card">
                            <div className="d-flex align-items-center justify-content-between ">
                                <h4 className="profile-heading m-0">Contact Information</h4>
                                <button className="edit-profile-btn rounded-3" onClick={() => navigate("/CreateProfile")}>
                                    <i className="fa-regular fa-edit me-2"></i>
                                    Edit Profile
                                </button>
                            </div>
                            <div className="contact_details border-0">
                                <div className="c_icon"><i className="fa-solid fa-mobile-screen"></i></div>
                                <div className="con_d">
                                    <h5>Phone:<br /> <span>{activeMobileDisplay}</span></h5>
                                </div>
                            </div>
                            <div className="contact_details">
                                <div className="c_icon"><i className="fa-regular fa-envelope"></i></div>
                                <div className="con_d">
                                    <h5>Email:<br /> <span>{userProfileData?.email || "NA"}</span></h5>
                                </div>
                            </div>
                            <div className="contact_details">
                                <div className="c_icon"><i className="fa-solid fa-location-dot"></i></div>
                                <div className="con_d">
                                    <h5>Address:<br /> <span>{userProfileData?.address || userProfileData?.new_location || "NA"}</span></h5>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <div className="info-card">
                            <h4 className="profile-heading">Login Details</h4>
                            <ul className="profile-list">
                                <li>
                                    <i className="fa-solid fa-chevron-right"></i>
                                    <b>First Name:</b> {formatName(userProfileData?.first_name)}
                                </li>
                                <li>
                                    <i className="fa-solid fa-chevron-right"></i>
                                    <b>Last Name:</b> {formatName(userProfileData?.last_name)}
                                </li> </ul>
                        </div>
                    </div>

                    <div className="col-lg-6 mb-4">
                        <div className="info-card">
                            <h4 className="profile-heading">Family Details</h4>
                            <ul className="profile-list">
                                <li><i className="fa-solid fa-chevron-right"></i><b>Brothers:</b> {userProfileData?.brothers_married || 0} married, {userProfileData?.brothers_unmarried || 0} unmarried</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Sisters:</b> {userProfileData?.sisters_married || 0} married, {userProfileData?.sisters_unmarried || 0} unmarried</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="info-card large-card mb-4">
                    <h4 className="profile-heading">Personal Information</h4>
                    <div className="row">
                        <div className="col-lg-6">
                            <ul className="profile-list">
                                <li><i className="fa-solid fa-chevron-right"></i><b>Gender:</b> <span style={{ textTransform: "capitalize" }}>{userProfileData?.gender || "NA"}</span>
                                </li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Petname:</b> {userProfileData?.petname || userProfileData?.pet_name || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Birth Date:</b> {userProfileData?.brithday || userProfileData?.birthday ? formatDate(userProfileData.brithday || userProfileData.birthday) : "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Birth Time:</b> {userProfileData?.birth_time || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Birth Place:</b> {userProfileData?.birth_place || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Height:</b> {formatHeight(userProfileData?.height)}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Weight:</b> {userProfileData?.weight ? `${parseFloat(userProfileData.weight)}kg` : "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Body
                                    Build:</b> <span style={{ textTransform: "capitalize" }}>{userProfileData?.body_build || "NA"}</span>
                                </li>
                                <li><i
                                    className="fa-solid fa-chevron-right"></i><b>Gotra:</b> <span style={{ textTransform: "capitalize" }}>{userProfileData?.gotra || "NA"}</span>
                                </li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Primary Contact Name:</b> {userProfileData?.contact_name || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Primary Contact Number:</b> +{userProfileData?.primary_country_code}-{userProfileData?.contact_number || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Primary Address:</b> {userProfileData?.new_location || "NA"}</li>
                            </ul>
                        </div>
                        <div className="col-lg-6">
                            <ul className="profile-list">
                                <li><i className="fa-solid fa-chevron-right"></i><b>Blood Group:</b> {userProfileData?.blood_group || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Native Place:</b> {userProfileData?.native_place || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Maternal Surname (Mamkul):</b> {userProfileData?.maternal_surname || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Marital Status:</b> <span style={{ textTransform: "capitalize" }}>{userProfileData?.marital_status || "NA"}</span>
                                </li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Horoscope Matching:</b> {userProfileData?.match_horoscope ? "Required" : "Not Required"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Work/Business/Agricultural Location:</b> {userProfileData?.location || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Is Handicapped:</b> {userProfileData?.is_handicapped ? "Yes" : "No"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Mentioned Disability:</b> {userProfileData?.disability_description || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Country:</b> <span style={{ textTransform: "capitalize" }}>{userProfileData?.country || "India"}</span>
                                </li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Secondary Contact Name:</b> {userProfileData?.sec_contact_name || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Secondary Contact Number:</b> +{userProfileData?.sec_country_code}-{userProfileData?.sec_contact_number || "NA"}</li>
                                <li><i className="fa-solid fa-chevron-right"></i><b>Secondary Address:</b> {userProfileData?.correspondence_address || "NA"}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                <div className="row">
                    <div className="col-lg-6 mb-4">
                        <div className="info-card">
                            <h4 className="profile-heading">Professional Details</h4>
                            <ul className="profile-list">
                                {(() => {
                                    // Safe lower-cased normalization
                                    const jobType = (userProfileData?.job_type || "").toLowerCase();
                                    const isJobless = jobType === "not working" || jobType === "searching for job";
                                    const isAgriculture = jobType === "agriculture";

                                    return (
                                        <>
                                            {/* 1. Main Occupation Row - ALWAYS VISIBLE for all job types */}
                                            <li>
                                                <i className="fa-solid fa-chevron-right"></i>
                                                <b>Occupation:</b> {userProfileData?.job_type || "NA"}
                                            </li>

                                            {/* Render secondary professional details only if they are working and NOT in agriculture */}
                                            {!isJobless && !isAgriculture && (
                                                <>
                                                    <li>
                                                        <i className="fa-solid fa-chevron-right"></i>
                                                        <b>Company Name:</b> {userProfileData?.organization_name || "NA"}
                                                    </li>
                                                    <li>
                                                        <i className="fa-solid fa-chevron-right"></i>
                                                        <b>Designation:</b> {userProfileData?.designation || "NA"}
                                                    </li>
                                                </>
                                            )}

                                            {/* Render Income only if they are working (includes Agriculture, excludes Jobless) */}
                                            {!isJobless && (
                                                <li>
                                                    <i className="fa-solid fa-chevron-right"></i>
                                                    <b>Income:</b> {userProfileData?.income || "NA"} INR
                                                </li>
                                            )}
                                        </>
                                    );
                                })()}
                            </ul>
                        </div>
                    </div>
                    <div className="col-lg-6 mb-4">
                        <div className="info-card">
                            <h4 className="profile-heading">Education Details</h4>
                            <ul className="profile-list">
                                <li><i className="fa-solid fa-chevron-right"></i><b>Highest
                                    Education:</b> {userProfileData?.heighest_education || userProfileData?.heighest_education || "NA"}
                                </li>
                                {String(userProfileData?.heighest_education || userProfileData?.education || "").toLowerCase() === "others" && userProfileData?.heighest_education_other && (
                                    <li><i className="fa-solid fa-chevron-right"></i><b>Highest Education
                                        Details:</b> {userProfileData.heighest_education_other}</li>
                                )}

                                <li><i className="fa-solid fa-chevron-right"></i><b>Second
                                    Highest:</b> {userProfileData?.second_heighest_education || userProfileData?.second_heighest_education || "NA"}
                                </li>
                                {String(userProfileData?.second_heighest_education || userProfileData?.second_highest_education || "").toLowerCase() === "others" && userProfileData?.second_heighest_education_other && (
                                    <li><i className="fa-solid fa-chevron-right"></i><b>Second Highest
                                        Details:</b> {userProfileData.second_heighest_education_other}</li>
                                )}
                                <li><i
                                    className="fa-solid fa-chevron-right"></i><b>Specialization:</b> {userProfileData?.education_stream || userProfileData?.specialization || "NA"}</li>
                            </ul>
                        </div>
                    </div>
                </div>

                {profileMedia.length > 0 && (
    <div className="mb-4">
        <h4 className="profile-heading mb-4">Photo/Video Gallery</h4>

        <Slider
            className="gallery-wrapper photo-gallery-section"
            {...photoGallery_slider}
        >
            {profileMedia.map((media, idx) => (
                <div className="event_img" key={idx}>

                    {media.type === "video" ? (
                        <div
                            className="gallery-video-wrapper"
                            onClick={() => setSelectedProfileIndex(idx)}
                        >
                            <video
                                src={media.url}
                                muted
                                preload="metadata"
                                playsInline
                                className="gallery-thumb"
                            />

                            <span className="gallery-play-icon">
                                ▶
                            </span>
                        </div>
                    ) : (
                        <img
                            style={{objectPosition:'top'}}
                            src={media.url}
                            alt={`Profile Gallery Item ${idx + 1}`}
                            onClick={() => setSelectedProfileIndex(idx)}
                            className="gallery-thumb"
                            onError={(e) => {
                                e.currentTarget.style.display = "none";
                            }}
                        />
                    )}

                </div>
            ))}
        </Slider>
    </div>
)}

                <div className="mb-4">
                    <h4 className="profile-heading mb-4">Social Media</h4>
                    <div className="social-icons">
                        {userProfileData?.social_instagram && <a href={userProfileData.social_instagram}><i className="fab fa-instagram"></i></a>}
                        {userProfileData?.social_facebook && <a href={userProfileData?.social_facebook}><i className="fab fa-facebook-f"></i></a>}
                        {userProfileData?.social_linkedin && <a href={userProfileData?.social_linkedin}><i className="fab fa-linkedin-in"></i></a>}
                    </div>
                </div>

                <h4 className="profile-heading">Partner Expectation</h4>
                <p className="partner-text">
                    {userProfileData?.partner_expectations || "-"}
                    {userProfileData?.partner_expectations_description}
                </p>
            </div>
{/* Profile Media Lightbox */}
{selectedProfileIndex !== null &&
    profileMedia[selectedProfileIndex] && (
        <div
            className="image_modal"
            onClick={() => setSelectedProfileIndex(null)}
        >
            <div
                className="modal_content"
                onClick={(e) => e.stopPropagation()}
            >

                {profileMedia.length > 1 && (
                    <button
                        type="button"
                        className="nav_btn prev_btn"
                        onClick={prevProfilePhoto}
                    >
                        ❮
                    </button>
                )}

                {profileMedia[selectedProfileIndex].type === "video" ? (
                    <video
                        key={profileMedia[selectedProfileIndex].url}
                        src={profileMedia[selectedProfileIndex].url}
                        controls
                        autoPlay
                        playsInline
                        className="modal_media"
                    />
                ) : (
                    <img
                        src={profileMedia[selectedProfileIndex].url}
                        alt="Enlarged Profile Selection"
                        className="modal_media"
                    />
                )}

                {profileMedia.length > 1 && (
                    <button
                        type="button"
                        className="nav_btn next_btn"
                        onClick={nextProfilePhoto}
                    >
                        ❯
                    </button>
                )}

               

            </div>
             <button
                    type="button"
                    className="close_btn"
                    onClick={() => setSelectedProfileIndex(null)}
                >
                    ✕
                </button>
        </div>
    )}
        </div>
    );
};

export default ProfileTab;